/* globals google */
class PlacesService {
  constructor (map, center) {
    this.service = new google.maps.places.PlacesService(map);
    this.center = center;
    this.radius = 8000;
  }

  setRadius (radius) {
    this.radius = radius;
  }

  search (type) {
    return new Promise((resolve, reject) => {
      return this.service.nearbySearch({
        location: this.center,
        radius: this.radius,
        keyword: type
      }, (result, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          return resolve(result);
        } else {
          reject(result, status);
        }
      });
    });
  }

  getDetails (placeId) {
    return new Promise((resolve, reject) => {
      this.service.getDetails({placeId}, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve({place, status});
        } else {
          reject(place, status);
        }
      });
    });
  }
}

module.exports = PlacesService;
